import Bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
import { application } from '@page2flip/core';

import { environment } from '../environments/environment';

const bugsnagClient = Bugsnag.start({
  apiKey: '6c48c244e00a28ed2028424b4e1a2d3e',
  appVersion: application.version + ' (#' + application.revision + ')',
  releaseStage: environment.production ? 'production' : 'development',
  enabledReleaseStages: [ 'production' ]
});

export function bugsnagFactory() {
  return new BugsnagErrorHandler(bugsnagClient);
}
